import React, { SVGAttributes } from 'react'
import styled from 'styled-components'
import { Theme } from '@mui/material/styles'

import { COLORS } from '~/common/globalStyles'

export interface SVGBaseProps {
  /** HEX/RGB or a key from COLORS constants  */
  color?: keyof typeof COLORS | string
  theme?: Theme
}

export type IconBaseProps = SVGAttributes<{}> & SVGBaseProps

const SVGBase = styled.svg.attrs<SVGBaseProps>((props) => ({
  fill: props.fill ?? 'currentColor',
  viewBox: props.viewBox ?? '0 0 20 20',
}))<SVGBaseProps>`
  vertical-align: middle;
  color: ${({ color }) => color};
`

const IconBase: React.FC<IconBaseProps> = ({
  color,
  width,
  height,
  ...props
}) => {
  return (
    <SVGBase
      width={width || height || '20px'}
      height={width || height || '20px'}
      color={color}
      {...props}
    />
  )
}

export default IconBase
